import { Link } from 'react-router-dom';
import { ArrowRight, Compass } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * V1 entry point into the future recommendation loop (current ability +
 * skills + weaknesses + trips + preferences + goals -> personalised trip
 * suggestions). That loop doesn't exist yet -- this deliberately just
 * surfaces the real, existing Trip Finder rather than fabricating
 * personalised recommendations the current backend can't support.
 *
 * Visually distinct from the informational sections above it on purpose:
 * this is the inspiration/action moment, not another data panel -- a solid
 * primary-toned block rather than a bordered card.
 */
const WhereNextCard = () => (
  <div className="rounded-2xl bg-primary text-primary-foreground px-6 py-8 sm:px-10 sm:py-10 text-center">
    <Compass className="h-7 w-7 mx-auto mb-3 opacity-90" />
    <h3 className="font-serif text-2xl sm:text-3xl leading-tight max-w-md mx-auto">
      Where could surfing take you next?
    </h3>
    <p className="mt-2 text-sm sm:text-base text-primary-foreground/80 max-w-sm mx-auto">
      Find a trip that fits your level and what you want to improve.
    </p>
    <Button asChild size="lg" variant="secondary" className="mt-6 gap-1.5 group">
      <Link to="/trip-planner">
        Find My Next Trip
        <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
      </Link>
    </Button>
  </div>
);

export default WhereNextCard;
